<template>
	<div>
		<hr>
		<div class="m-header-wrapper">
			<table class="m-header">
				<thead class='bold'>
					<tr>
						<td class='m-td'>Федеральный округ</td>
						<td class='m-td'>Количество</td>
					</tr>
				</thead>		
				<tbody>
					<tr v-for='(row, i) in rows'>
						<td>{{row.fo}}</td>
						<td>{{row.count}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import router from '../../router'
	import {DB} from './../../constants'
	import { EventBus } from '../../lib/EventBus'

	const GET_WARRANTS_COUNT = 'get_warrants_count.php'
	const REPORT_ID = 8

	export default {
		name: 'WarrantsCount',
		data: function () {
			return {
				rows: []
			}
		},
		props: [
			'start',
			'end'
		],
		methods: {
			fillTable (start,end) {
				fetch(DB + GET_WARRANTS_COUNT + '?start=' + start + '&end=' + end)
				.then(res => res.json())
				.then(res => {
					this.rows = res
			})
				.catch(err => console.log(err))
			}
		},
		mounted () {
			this.rows = []
			this.fillTable(this.start, this.end)

			EventBus.$on('report-date', date => {
				// console.log('mon',date)
				this.fillTable(date.start, date.end)
			})
			/*
			const dispay_width = document.documentElement.clientWidth
			const dispay_height = document.documentElement.clientHeight
			let scroll_width = 17

			const ua = navigator.userAgent

			// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

			if (ua.search('OPR/') > 0) {
				scroll_width = 15
			}

			const table_width = dispay_width - 30 - scroll_width
			const col_width = Math.ceil(table_width / 13)
			

			document.querySelectorAll('.m-td').forEach(td => {
				td.width = col_width
			})
			document.querySelector('.m-header-wrapper').width = table_width
			document.querySelector('.m-body-wrapper').width = table_width
			document.querySelector('.m-body-wrapper').style.maxHeight = `${dispay_height - 340}px`

			// console.log(dispay_width, col_width, table_width)

			document.querySelector('.m-scroll').width = scroll_width*/

		},
		created() {
			if(!this.$parent.$parent.reports.some((e) => {
				return e.id == REPORT_ID
			}))
				router.replace('/main')
		},
		beforeDestroy() {
			EventBus.$off('report-date')
		}
	}
</script>

<style scoped>
	.left {
		text-align: left;
		padding-left: 2px;
	}

	.right {
		text-align: right;
		padding-right: 10px;
	}

	div.m-header-wrapper {
		border-bottom: none;  
    	display: flex;
    	justify-content: center;
	}

	div.m-body-wrapper {
		overflow-x: hidden;
		overflow-y: auto;
		border-top: none;
	}

	table.m-header {
		table-layout: fixed;
		/*width: 100%;*/
	}

	table.m-body {
		table-layout: fixed;
		/*width: 100%;*/
	}
	
 	td.m-td, th.m-td {
		vertical-align: middle;  
		word-wrap: break-word;
	} 

	td, th {
		padding: 5px 15px;
	}
</style>



// WEBPACK FOOTER //
// WarrantsCount.vue?414a30c7